import {DynamicData} from '../../data/DynamicData';
import {StaticData} from '../../data/StaticData';
import {Sprite} from 'pixi.js';
import {PlayerData} from '../../data/active_data/field_config/PlayerData';
import {BackgroundAndCardsHolder} from './hand/BackgroundAndCardsHolder';
import {NewPixiSceneEvents} from '../../events/NewPixiSceneEvents';
import {CardSelector} from '../../controllers/CardSelector';
import {HandEvents} from './hand/HandEvents';

export class Hand extends Sprite
{
    readonly backgroundAndCardsHolder: BackgroundAndCardsHolder;
    private onPlayersUpdatedBindThis: (e: Event) => void;

    constructor() {
        super();
        this.backgroundAndCardsHolder = new BackgroundAndCardsHolder();

        this.addChild(this.backgroundAndCardsHolder);

        this.onPlayersUpdatedBindThis = this.onPlayersUpdated.bind(this);
        if (!StaticData.isAdmin) {
            addEventListener(NewPixiSceneEvents.PLAYERS_UPDATED, this.onPlayersUpdatedBindThis);
            this.onPlayersUpdated();
        }
    }

    resize() {
        this.backgroundAndCardsHolder.resize();
    }

    async initialize(playerData: PlayerData): Promise<void> {
        await this.backgroundAndCardsHolder.initialize(playerData);
        this.resize();
        this.backgroundAndCardsHolder.updateHandEmptyTextVisibility();
        dispatchEvent(new MessageEvent(HandEvents.UPDATED));
    }

    destroy(): void {
        removeEventListener(NewPixiSceneEvents.PLAYERS_UPDATED, this.onPlayersUpdatedBindThis);
        delete this.onPlayersUpdatedBindThis;
        super.destroy({children: true});
    }

    private onPlayersUpdated(e?: Event): void {
        e;

        let isGuest: boolean = DynamicData.players.find(player => player.id == StaticData.playerId)!.isGuest;
        if (isGuest) {
            CardSelector.unselectAll();
        }
        if (StaticData.isAdmin) {
            this.interactive = this.interactiveChildren = this.buttonMode = false;
        } else {
            this.interactive = this.interactiveChildren = this.buttonMode = !isGuest;
        }

        dispatchEvent(new MessageEvent(HandEvents.UPDATED));
    }
}
